import { RefreshCw } from "lucide-react";

export function ResetButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-1 px-3 py-2.5 bg-white border border-gray-200 rounded-lg text-sm text-gray-600 shadow-sm hover:bg-gray-50 focus:ring-2 focus:ring-primary"
    >
      <RefreshCw size={14} />
      Reset
    </button>
  );
}
